<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 2.75227C7.5 2.33806 7.16421 2.00227 6.75 2.00227C6.33579 2.00227 6 2.33806 6 2.75227V7H3C2.44772 7 2 7.44772 2 8V12C2 12.5523 2.44772 13 3 13H6V17.2477C6 17.6619 6.33579 17.9977 6.75 17.9977C7.16421 17.9977 7.5 17.6619 7.5 17.2477L7.5 13H12.5V17.2477C12.5 17.6619 12.8358 17.9977 13.25 17.9977C13.6642 17.9977 14 17.6619 14 17.2477V13H17C17.5523 13 18 12.5523 18 12V8C18 7.44772 17.5523 7 17 7H14V2.75227C14 2.33806 13.6642 2.00227 13.25 2.00227C12.8358 2.00227 12.5 2.33806 12.5 2.75227V7H7.5L7.5 2.75227Z"
      fill="currentColor"
    />
  </svg>
</template>
